import { render, staticRenderFns } from "./InsurerRisk.vue?vue&type=template&id=0f68288b&scoped=true"
import script from "./InsurerRisk.vue?vue&type=script&lang=js"
export * from "./InsurerRisk.vue?vue&type=script&lang=js"
import style0 from "./InsurerRisk.vue?vue&type=style&index=0&id=0f68288b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f68288b",
  null
  
)

export default component.exports